import React from "react";
import Typography from "../../../common/Typography/Typography";
import Button from "../../../common/Buttons/Button/Button";
import FileItem from "../../../FileDirectory/FileItem/FileItem";
import { PDF_USER_GUIDE } from "../../../../config/global.config";
import { SlideProps } from "../types";

const EndSlide = ({ onClose }: SlideProps) => (
    <div className="flex flex-col gap-1.5 pb-1">
        <Typography variant="paragraph">
            You're all done!{" "}
            {PDF_USER_GUIDE ? "If you'd like some help finding your way around you can use the handy user guide below." : ""}
        </Typography>
        {PDF_USER_GUIDE ? (
            <div className="space-y-1 flex flex-col">
                <FileItem
                    name="PDF User Guide"
                    icon="download"
                    onClick={() => {
                        // open PDF_USER_GUIDE in a new tab

                        window.open(PDF_USER_GUIDE, "_blank");
                    }}
                />
            </div>
        ) : null}
        <Button variant="primary" size="large" onClick={onClose}>
            No thanks, Sign me in
        </Button>
    </div>
);

export default EndSlide;
